(function($) {
  "use strict";
  $(function() {
    function getHashFilter() {
      var hash = location.hash;
      // get filter=filterName
      var matches = location.hash.match(/filter=([^&]+)/i);
      if (!matches) {
        return "";
      }
      return decodeURIComponent(matches[1]);
    }

    // debounce so filtering doesn't happen every millisecond
    function debounce(fn, threshold) {
      var timeout;
      threshold = threshold || 100;
      return function debounced() {
        clearTimeout(timeout);
        var args = arguments;
        var _this = this;
        function delayed() {
          fn.apply(_this, args);
        }
        timeout = setTimeout(delayed, threshold);
      };
    }

    // flatten object by concatting values
    function concatValues(obj) {
      var value = "";
      for (var prop in obj) {
        value += obj[prop];
      }
      return value;
    }

    function getFilterSelector(hashFilter) {
      var filters = hashFilter.substring(1).split(".");
      return filters;
    }

    $(".search-form").submit(function(e) {
      e.preventDefault();

      location.href = `${localize.programsPage}?k=${$(".input-search").val()}`;
    });

    if ($(".t-programs-archive").length) {
      $.grid = $(".programs-cards__wrapper").isotope({});

      var $search_input = $.getUrlParameter("k");
      var qsRegex;

      if ($search_input) {
        qsRegex = new RegExp(`${$search_input}`, "gi");
        $(".search__input")
          .val(`${$search_input}`)
          .trigger("propertychange");
      }

      var filters = {};

      $('.has-clear input[type="text"]')
        .on("input propertychange", function() {
          var $this = $(this);
          var visible = Boolean($this.val());
          $this.siblings(".js-clear-search").toggleClass("d-none", !visible);
        })
        .trigger("propertychange");

      $(".js-clear-search").click(function() {
        $(this)
          .siblings('input[type="text"]')
          .val("")
          .trigger("propertychange")
          .focus();
      });

      // use value of search field to filter
      var $quicksearch = $(".search__input").on(
        "input propertychange",
        debounce(function() {
          qsRegex = new RegExp($quicksearch.val(), "gi");
          $.grid.isotope();
        })
      );

      $(".js-nav-filter").on("click", function() {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
        } else {
          $(".js-nav-filter").removeClass("active");
          $(this).addClass("active");
        }

        var $this = $(this);
        var filterGroup = $this.attr("data-filter-group");

        const filter = $this.hasClass("active")
          ? $this.attr("data-filter")
          : "";

        filters[filterGroup] = filter;
        // combine filters
        var filterValue = concatValues(filters);
        $.grid.isotope();

        location.hash = "filter=" + encodeURIComponent(filterValue);
      });

      $(".js-filter").on("change", function() {
        var $this = $(this);
        var filterGroup = $this.attr("data-filter-group");
        // set filter for group
        filters[filterGroup] = $this.val();
        // combine filters
        var filterValue = concatValues(filters);
        $.grid.isotope();
        location.hash = "filter=" + encodeURIComponent(filterValue);
      });

      var isIsotopeInit = false;

      function onHashchange() {
        var hashFilter = getHashFilter();

        // filter isotope
        $.grid.isotope({
          itemSelector: ".grid-item",
          //filter: hashFilter
          filter: function() {
            var $this = $(this);
            var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
            var buttonResult = hashFilter ? $this.is(hashFilter) : true;
            return searchResult && buttonResult;
          },
        });
        if (!isIsotopeInit && hashFilter) {
          var filterSelector = getFilterSelector(hashFilter);

          $.each(filterSelector, function(i, e) {
            if (e != "*" && e != "") {
              var $current_filter = $(`[data-filter=".${e}"]`);
              if ($current_filter.length && $current_filter.parent()[0].sumo) {
                $current_filter.parent()[0].sumo.selectItem(`.${e}`);
              } else {
                $(`[data-filter=".${e}"]`).addClass("active");
              }
            }
          });
        }

        if (!$(".programlist-wrapper").hasClass("loaded")) {
          $(".loading-overlay").fadeOut("300", function() {
            $(".programlist-wrapper").addClass("loaded");
          });
        }

        isIsotopeInit = true;
      }

      $(window).on("hashchange", onHashchange);

      // trigger event handler to init Isotope
      onHashchange();

      $.grid.on("arrangeComplete", function(event, filteredItems) {
        if (filteredItems.length == 0) {
          $(".js-isotope-no-results").addClass("active");
        } else {
          $(".js-isotope-no-results").removeClass("active");
        }
      });
    }
  });
})(jQuery);
